import { removeMultipleDots } from '../removeMultipleDots';

type maskOptionsType = { ignoreEmpty?: boolean };

export const getUSDTransform = (options: {
  maxValue: number;
  maxDecimalsLength: number;
}) => {
  const { maxValue, maxDecimalsLength } = options;

  return {
    mask(value: string | number | undefined, options?: maskOptionsType) {
      const ignoreEmpty = options?.ignoreEmpty ?? false;

      if ((value === undefined || value === '') && !ignoreEmpty) {
        return '';
      }

      return `$${value !== undefined ? value : ''}`;
    },
    mapper(event: React.ChangeEvent<HTMLInputElement>) {
      let value = event.target.value;
      value = value.replace('$', '');

      value = value.replace(',', '.');
      value = value === '.' ? '0.' : value;
      value = value.replace(/^00+/g, '0');

      const cleanValue = removeMultipleDots(value.replace(/[^0-9.]/g, ''));

      const [intPart, decimalNumber] = cleanValue.split('.');

      if (decimalNumber && decimalNumber.length > maxDecimalsLength) {
        return [intPart, decimalNumber.slice(0, maxDecimalsLength)].join('.');
      }

      if (Number(cleanValue) > maxValue) {
        return String(maxValue);
      }

      return cleanValue;
    },
  };
};
